import type {AxiosRequestConfig} from 'axios';

export class GetAllParcelLogsRequestBuilder {
  private readonly parcelRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/parcel-logs',
    params: {},
  };

  id(id: number) {
    this.parcelRequest.url = `/parcels/${id}/logs`;
    return this;
  }
  params(params: object) {
    this.parcelRequest.params = params;
    return this;
  }

  build() {
    return this.parcelRequest;
  }
}
